import React from 'react';
import { Image } from '../Image';
import { RichH4, RichHeadlineCaption, RichP2 } from '../Typography';
import styled from 'styled-components';
import media from '../../utils/media';
import { getParsedField } from '../../utils/helpers';
const CardContainer = styled.div `
  background: ${({ color }) => color};
  width: 100%;
  height: auto;
  flex: 1 0 0;
  ${media.mobile} {
    min-width: 100%;
  }
`;
const ContentContainer = styled.div `
  padding-bottom: 40px;
  ${media.mobile} {
    padding-bottom: 75px;
    padding-left: 3%;
    padding-right: 3%;
  }
`;
const ImageContainer = styled.div `
  height: 110px;
`;
const CardImage = styled(Image) `
  display: inline-block;
  margin-top: 40px;
  width: auto;
  max-width: 141px;
  height: auto;
  max-height: 65px;
`;
const ContentTitle = styled(RichH4) `
  margin: 20px 8.99% 0px 8.99%;
`;
const ContentSubtitle = styled(RichHeadlineCaption) `
  margin: 10px 8.99% 0;
`;
const ContentBody = styled(RichP2) `
  margin: 4px 8.99% 0;
`;
export const HorizontalCard = ({ fields, color, }) => {
    if (!fields) {
        console.warn('HorizontalCard component requires fields to be provided');
        return null;
    }
    const { title, subTitle, bodyText, logo } = fields;
    const parsedTitle = getParsedField(title);
    const parsedSubtitle = getParsedField(subTitle);
    const parsedBodytext = getParsedField(bodyText);
    const image = logo && logo.value;
    return (React.createElement(CardContainer, { color: color },
        React.createElement(ContentContainer, null,
            React.createElement(ImageContainer, null,
                React.createElement(CardImage, { media: image, width: null, height: null })),
            title && React.createElement(ContentTitle, { asWhite: true, field: parsedTitle }),
            subTitle && React.createElement(ContentSubtitle, { asWhite: true, field: parsedSubtitle }),
            bodyText && React.createElement(ContentBody, { asWhite: true, field: parsedBodytext }))));
};
export default HorizontalCard;
